import React, { Component } from "react";

import { CLabel, CTextarea } from "@coreui/react";
import cep from "cep-promise";
import DatePicker from "react-date-picker";
import { connect } from "react-redux";
import Select from "react-select";
import {
  Button,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Label,
  FormGroup
} from "reactstrap";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { createTextMask } from "redux-form-input-masks";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

class FormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // edit: this.props.edit,
      // valueDataForm: null
    };
    this.phoneMask = createTextMask({
      pattern: "+99(99) 9 9999-9999",
      stripMask: false
    });

    this.cepMask = createTextMask({
      pattern: "99999-999"
    });

    this.cpfMask = createTextMask({
      pattern: "999.999.999-99"
    });
    this.Grequire = {};
    this.errors = {};
    this.back = this.back.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {}

  renderSelectInput = ({
    input,
    label,
    type,
    options,
    require,
    onSelect,
    icon
  }) => {
    if (require) {
      this.Grequire.push({ name: label, marked: false });
    }
    // options.reverse()
    return (
      <>
        {}
        <FormGroup className="">
          <CLabel>{label}</CLabel>
          <InputGroup>
            {icon ? (
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className={icon}></i>
                </InputGroupText>
              </InputGroupAddon>
            ) : (
              ""
            )}
            <Input {...input} name={label} type={type} placeholder={label}>
              {label !== "Conteúdo Flash" ? (
                <option key="0">{label}</option>
              ) : (
                <></>
              )}

              {options.map((elem, idx) => (
                <option key={idx + 1} value={elem.value}>
                  {elem.name}
                </option>
              ))}
            </Input>
          </InputGroup>
          <span className="text-danger">{this.errors[label] || ""}</span>
        </FormGroup>
      </>
    );
  };

  renderSelectInputSearch = ({
    input,
    label,
    type,
    options,
    require,
    onSelect,
    icon
  }) => {
    if (require) {
      this.Grequire.push({ name: label, marked: false });
    }
    return (
      <FormGroup className="">
        <CLabel>{label}</CLabel>
        <InputGroup>
          {icon ? (
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className={icon}></i>
              </InputGroupText>
            </InputGroupAddon>
          ) : (
            ""
          )}
          <Select
            placeholder={label}
            onChange={input.onChange}
            options={options}
            defaultValue={input.value}
          />
        </InputGroup>
        <span className="text-danger">{this.errors[label] || ""}</span>
      </FormGroup>
    );
  };

  // Mount the checkbox input
  renderCheckboxInput = ({
    input,
    label,
    type,
    require,
    options,
    size,
    icon
  }) => (
    <FormGroup className="formCard">
      <CLabel>{label}</CLabel>
      <Col md="3">
        <Label>{label}</Label>
      </Col>
      <Col md="9">
        {options.map((elem, idx) => (
          <FormGroup key={idx} check className="checkbox">
            <Field
              component={this.renderCheckboxInputFase2}
              checkValue={input.value}
              type="checkbox"
              label={elem.name}
              name={elem.name}
            />
          </FormGroup>
        ))}
      </Col>
      <span className="text-danger">{this.errors[label] || ""}</span>
    </FormGroup>
  );

  changeFile = (e, onChange) => {};

  renderFieldFile = ({
    input,
    label,
    type,
    require,
    meta: { touched, error, warning },
    icon
  }) => (
    <FormGroup className="mb3">
      <CLabel>{label}</CLabel>
      <InputGroup>
        {icon ? (
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className={icon}></i>
            </InputGroupText>
          </InputGroupAddon>
        ) : (
          ""
        )}
        <Input
          {...input}
          type={type}
          placeholder={label}
          onChange={e => {
            this.changeFile(e, input.onChange);
          }}
        />
        {touched &&
          ((error && <span className="tip">{error}</span>) ||
            (warning && <span className="tip">{warning}</span>))}
      </InputGroup>
      <span className="text-danger">{this.errors[label] || ""}</span>
    </FormGroup>
  );

  renderCheckboxInputFase2 = ({
    input,
    label,
    type,
    checkValue,
    require,
    size,
    meta: { touched, error, warning }
  }) => (
    <FormGroup className=" mb3">
      <CLabel>{label}</CLabel>
      <InputGroup>
        <Input
          {...input}
          type={type}
          placeholder={label}
          key={label}
          defaultChecked={checkValue === label}
        />
        <Label check className="form-check-label" htmlFor={label}>
          {label}
        </Label>
      </InputGroup>
      <span className="text-danger">{this.errors[label] || ""}</span>
    </FormGroup>
  );
  // Mount the radio input

  renderRadioInput = ({
    input,
    label,
    name,
    type,
    defautValue,
    require,
    icon,
    meta: { touched, error, warning }
  }) => {
    input.value = defautValue;
    return (
      <FormGroup className="mb3">
        <CLabel>{label}</CLabel>
        <InputGroup>
          {icon ? (
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className={icon}></i>
              </InputGroupText>
            </InputGroupAddon>
          ) : (
            ""
          )}
          <Input
            {...input}
            type={type}
            placeholder={label}
            value={defautValue}
            checked={input.value === defautValue}
          />
          <div className="form-control">
            <Label className="form-radio-label" htmlFor={name}>
              {label}
            </Label>
          </div>

          {touched &&
            ((error && <span className="tip">{error}</span>) ||
              (warning && <span className="tip">{warning}</span>))}
        </InputGroup>
        <span className="text-danger">{this.errors[label] || ""}</span>
      </FormGroup>
    );
  };

  renderFieldPassword = ({
    input,
    label,
    type,
    require,
    retype,
    icon,
    size,
    meta: { touched, error, warning }
  }) => (
    <FormGroup>
      <CLabel>{label}</CLabel>
      <InputGroup>
        {icon ? (
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className={icon}></i>
            </InputGroupText>
          </InputGroupAddon>
        ) : (
          ""
        )}
        <Input {...input} type={type} placeholder={label} />
        {touched &&
          ((error && <span className="tip">{error}</span>) ||
            (warning && <span className="tip">{warning}</span>))}
      </InputGroup>
      <span className="text-danger">{this.errors[label] || ""}</span>
    </FormGroup>
  );

  renderFieldDate = ({
    input,
    label,
    icon,
    fieldName,
    meta: { touched, error, warning }
  }) => {
    let date = null;
    if (this.props.valueData) {
      if (input.value !== "" && input.value !== undefined) {
        date = new Date(input.value);
      }
    }

    if (!input.value) {
      error = "Este campo é obrigatório";
    }

    return (
      <FormGroup className="mb3">
        <CLabel>{label}</CLabel>
        <InputGroup>
          {icon ? (
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className={icon}></i>
              </InputGroupText>
            </InputGroupAddon>
          ) : (
            ""
          )}
          <DatePicker
            onChange={date => input.onChange(date)}
            value={date}
            className="date-picker"
            format="dd/MM/yyyy"
          />
          {touched &&
            ((error && <span className="tip">{error}</span>) ||
              (warning && <span className="tip">{warning}</span>))}
        </InputGroup>
        <span className="text-danger">{this.errors[label] || ""}</span>
      </FormGroup>
    );
  };

  renderField = ({
    input,
    label,
    type,
    valueDefaut,
    require,
    icon,
    size,
    meta: { touched, error, warning }
  }) => (
    <FormGroup className="mb3">
      <CLabel>{label}</CLabel>
      <InputGroup>
        {icon ? (
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className={icon}></i>
            </InputGroupText>
          </InputGroupAddon>
        ) : (
          ""
        )}
        <Input {...input} type={type} placeholder={label} />
        {touched &&
          ((error && <span className="tip">{error}</span>) ||
            (warning && <span className="tip">{warning}</span>))}
      </InputGroup>
      <span className="text-danger">{this.errors[label] || ""}</span>
    </FormGroup>
  );

  renderCepField = ({
    input,
    label,
    type,
    require,
    icon,
    size,
    onCepResolved,
    meta: { touched, error, warning }
  }) => {
    const handleBlur = event => {
      input.onBlur(event);

      const rawCep = (event.target.value || "").replace(/\D/g, "");
      if (rawCep.length === 8 && onCepResolved) {
        cep(rawCep)
          .then(address => onCepResolved(address))
          .catch(() => onCepResolved(null));
      }
    };

    return (
      <FormGroup className="mb3">
        <CLabel>{label}</CLabel>
        <InputGroup>
          {icon ? (
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className={icon}></i>
              </InputGroupText>
            </InputGroupAddon>
          ) : (
            ""
          )}
          <Input
            {...input}
            onBlur={handleBlur}
            type={type}
            placeholder={label}
          />
          {touched &&
            ((error && <span className="tip">{error}</span>) ||
              (warning && <span className="tip">{warning}</span>))}
        </InputGroup>
        <span className="text-danger">{this.errors[label] || ""}</span>
      </FormGroup>
    );
  };

  renderTextarea = ({
    input,
    label,
    type,
    valueDefaut,
    require,
    icon,
    size,
    lines,
    meta: { touched, error, warning }
  }) => (
    <FormGroup className="mb3">
      <CLabel>{label}</CLabel>
      <InputGroup>
        {icon ? (
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className={icon}></i>
            </InputGroupText>
          </InputGroupAddon>
        ) : (
          ""
        )}
        <CTextarea {...input} placeholder={label} rows={lines} />
        {touched &&
          ((error && <span className="tip">{error}</span>) ||
            (warning && <span className="tip">{warning}</span>))}
      </InputGroup>
      <span className="text-danger">{this.errors[label] || ""}</span>
    </FormGroup>
  );

  back = () => {
    this.props.history.goBack();
  };

  render() {
    const { fields, buttons, pristine, handleSubmit, submitting, children } =
      this.props;
    this.gFields = fields;
    let radioController = "";

    return (
      <React.Fragment>
        {this.props.back ? (
          <div className="headerButtonGroup">
            <button
              onClick={this.back}
              className="ml-auto back btn btn-primary"
            >
              <i className="fa fa-history "></i> Voltar
            </button>
          </div>
        ) : (
          ""
        )}
        <form
          ref={this.props.formRef}
          onSubmit={handleSubmit}
          className="formComponent row"
        >
          {children}
          {fields.map((field, idx) =>
            field.type === "select" ? (
              <React.Fragment key={idx}>
                <Col sm="12" md={field.size}>
                  <React.Fragment>
                    {field.search ? (
                      <Field
                        size={field.size}
                        options={field.options}
                        require={field.require}
                        component={this.renderSelectInputSearch}
                        icon={field.icon}
                        type={field.type}
                        label={field.label}
                        name={field.name}
                        onSelect={field.custonSelect}
                      />
                    ) : (
                      <Field
                        size={field.size}
                        options={field.options}
                        require={field.require}
                        component={this.renderSelectInput}
                        icon={field.icon}
                        type={field.type}
                        label={field.label}
                        name={field.name}
                        onSelect={field.custonSelect}
                      />
                    )}
                  </React.Fragment>
                </Col>
              </React.Fragment>
            ) : field.type === "checkbox" ? (
              <React.Fragment key={idx}>
                <Col sm="12" md={field.size}>
                  <Field
                    size={field.size}
                    options={field.options}
                    require={field.required}
                    component={this.renderCheckboxInput}
                    icon={field.icon}
                    type={field.type}
                    label={field.label}
                    name={field.name}
                  />
                </Col>
              </React.Fragment>
            ) : field.type === "radio" ? (
              <React.Fragment key={idx}>
                {radioController !== field.name ? (
                  <React.Fragment>
                    <h3>{(radioController = field.name)}</h3>
                  </React.Fragment>
                ) : (
                  ""
                )}
                <Col sm="12" md={field.size}>
                  <Field
                    require={field.require}
                    defautValue={field.value}
                    component={this.renderRadioInput}
                    icon={field.icon}
                    type={field.type}
                    label={field.label}
                    name={field.name}
                  />
                </Col>
              </React.Fragment>
            ) : field.type === "password" ? (
              <React.Fragment key={idx}>
                {field.outOnEdit && this.props.edit ? (
                  ""
                ) : (
                  <Col sm="12" md={field.size}>
                    <Field
                      size={field.size}
                      validate={field.validate}
                      require={field.require}
                      component={this.renderFieldPassword}
                      icon={field.icon}
                      type={field.type}
                      label={field.label}
                      name={field.name}
                    />
                  </Col>
                )}
              </React.Fragment>
            ) : field.type === "phone" ? (
              <React.Fragment key={idx}>
                <Col sm="12" md={field.size}>
                  <Field
                    size={field.size}
                    options={field.options}
                    require={field.require}
                    component={this.renderField}
                    icon={field.icon}
                    type="tel"
                    label={field.label}
                    name={field.name}
                    {...this.phoneMask}
                  />
                </Col>
              </React.Fragment>
            ) : field.type === "date" ? (
              <React.Fragment key={idx}>
                <Col sm="12" md={field.size}>
                  <Field
                    size={field.size}
                    options={field.options}
                    require={field.require}
                    component={this.renderFieldDate}
                    icon={field.icon}
                    type={field.type}
                    label={field.label}
                    name={field.name}
                    fieldName={field.name}
                  />
                </Col>
              </React.Fragment>
            ) : field.type === "file" ? (
              <React.Fragment>
                <Col key={idx} sm="12" md={field.size}>
                  <Field
                    size={field.size}
                    validate={field.validate}
                    options={field.options}
                    require={field.require}
                    component={this.renderFieldFile}
                    icon={field.icon}
                    type="file"
                    label={field.label}
                    name={field.name}
                  />
                </Col>
              </React.Fragment>
            ) : field.type === "cep" ? (
              <React.Fragment>
                <Col key={idx} sm="12" md={field.size}>
                  <Field
                    size={field.size}
                    validate={field.validate}
                    options={field.options}
                    require={field.require}
                    component={this.renderCepField}
                    icon={field.icon}
                    type="cep"
                    label={field.label}
                    name={field.name}
                    onCepResolved={field.onCepResolved}
                    {...this.cepMask}
                  />
                </Col>
              </React.Fragment>
            ) : field.type === "textarea" ? (
              <React.Fragment key={idx}>
                <Col sm="12" md={field.size}>
                  <Field
                    size={field.size}
                    valueDefaut={field.value}
                    lines={field.lines}
                    validate={field.validate}
                    component={this.renderTextarea}
                    icon={field.icon}
                    require={field.require}
                    type={field.type}
                    label={field.label}
                    name={field.name}
                  />
                </Col>
              </React.Fragment>
            ) : (
              <React.Fragment key={idx}>
                <Col sm="12" md={field.size}>
                  <Field
                    size={field.size}
                    valueDefaut={field.value}
                    validate={field.validate}
                    component={this.renderField}
                    icon={field.icon}
                    require={field.require}
                    type={field.type}
                    label={field.label}
                    name={field.name}
                  />
                </Col>
              </React.Fragment>
            )
          )}
        </form>
        {this.props.edit && this.props.updatePassword ? (
          <Col md={6}>
            <Button
              className="changePassword"
              onClick={this.openModal}
              color="secondary"
            >
              <i className="fa fa-key" />
              Mudar Senha
            </Button>
          </Col>
        ) : (
          ""
        )}

        {buttons
          ? buttons.map((elem, idx) => (
              <Col key={idx} className="ml-auto text-right">
                <Button
                  onClick={handleSubmit}
                  color={elem.color}
                  disabled={pristine || submitting}
                  type={elem.submit ? "submit" : ""}
                >
                  {elem.icon ? <i className={`${elem.icon} submitForm`} /> : ""}{" "}
                  {elem.name}
                </Button>
              </Col>
            ))
          : ""}
      </React.Fragment>
    );
  }
}

const Form = reduxForm({
  form: "formBase"
})(FormComponent);

const mapStateToProps = state => ({ user: state.user });

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(Form);
